/**
 * Expiry shown to customers = the last day they can use the service (JST).
 * A term ending 2026-11-29 00:00 JST is shown as 2026/11/28 (Findings #9).
 */
export function lastUsableDate(license) {
  if (!license) return null;
  if (license.lastServiceDate) return new Date(license.lastServiceDate);
  const end = license.subscriptionEndDate || license.periodEndDate;
  if (!end) return null;
  const date = new Date(new Date(end).getTime() - 1);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function formatJstDate(date, language) {
  if (!date) return "";
  return date.toLocaleDateString(language === "en" ? "en-US" : "ja-JP", { timeZone: "Asia/Tokyo" });
}

/** Days left counted by JST calendar date, today included. */
export function jstDaysLeft(license, now = new Date()) {
  const fromServer = Number(license?.subscriptionDaysRemaining ?? license?.daysRemaining);
  if (Number.isFinite(fromServer)) return Math.max(0, fromServer);
  const last = lastUsableDate(license);
  if (!last) return null;
  const key = (d) => new Date(d.getTime() + 9 * 3600 * 1000).toISOString().slice(0, 10);
  const days = Math.round((Date.parse(key(last)) - Date.parse(key(now))) / 86400000) + 1;
  return Math.max(0, days);
}
